<template>
  <a-modal
      title="整组专家情况"
      :width="1080"
      :visible="visible"
      :maskClosable="false"
      @cancel="$emit('cancel')"
      :confirmLoading="loading"
      destroyOnClose
      okText="确定"
      @ok="onSubmit">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="12" :lg="8" :sm="24">
            <a-form-model-item label="专家名称">
              <a-input @keyup.enter="onSearch" placeholder="请输入专家名称关键字查询" v-model="queryForm.name"/>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :lg="8" :sm="24">
            <a-form-item label="单位名称">
              <a-input placeholder="请输入单位名称关键字查询" v-model="queryForm.unitName"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="onSearch">查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :pagination="pagination"
        :rowKey="record => record.id">
      <template slot="name" slot-scope="record">
        <a @click="onViewModal(record)">{{ record.name }}</a>
      </template>
      <template slot="operation" slot-scope="record">
        <a-button @click="onViewReSelectModal(record,'2')" :loading="loading" type="primary">确定</a-button>&nbsp;
      </template>
    </s-table>

    <a-modal :title="reSelectTitle" v-model="reSelectVisible" :width="960" @ok="onOkReSelectModal">
      <table class="fx-form-view">
        <col width="150px"/>
        <col/>
        <tr>
          <th>专家名称</th>
          <td colspan="3">
            <div v-if="reSelectState === '3'">
              <span v-for="expert in selectExpertList">{{ expert.name }} &nbsp;</span>
            </div>
            <div v-else>{{ reSelectExpert.name }}</div>
          </td>
        </tr>
        <tr>
          <th>是否回避</th>
          <td colspan="3">
            <a-radio-group v-model="debarb">
              <a-radio :value="'1'">是</a-radio>
              <a-radio :value="'0'">否</a-radio>
            </a-radio-group>
          </td>
        </tr>
        <tr>
          <th>理由</th>
          <td colspan="3">
            <a-textarea v-model="reSelectReason" :rows="2"/>
          </td>
        </tr>
      </table>
    </a-modal>
    <expertView-modal :visible="evmVisible" :id="evmId" @cancel="evmVisible = false; evmId = null"/>
  </a-modal>
</template>

<script>
import STable from '@/components/Table'
import expertViewModal from '@/epp/expertmain/expertInfo/common/ExpertViewModal.vue'

export default {
  name: 'SelectExpertModal',
  components: {
    STable,
    expertViewModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dutyHalfDay: {
      type: Boolean,
      default: false
    }
  },
  created () {

  },
  data () {
    return {
      form: this.$form.createForm(this),
      user: this.$ls.get('user'),
      queryForm: {
        name: undefined,
        unitName: undefined
      },
      loading: false,
      deptDisabled: false,
      // 专家详情模态框
      evmVisible: false,
      evmId: null,
      // 重抽理由模态框
      reSelectVisible: false,
      reSelectTitle: null,
      reSelectExpert: { id: null, name: null },
      debarb: '0',
      reSelectReason: null,
      reSelectState: '1',
      reSelectList: [],
      // 随机选取专家列表
      selectExpertList: [],
      // 确定选取专家列表
      confirmExpertList: [],
      // 确定选取专家列表
      cancelExpertList: [],
      columns: [],
      total: '',
      selType: undefined,
      pagination: {
        showTotal: total => `共 ${this.total} 条`
      },
      loadData: parameter => {
        return this.$http.get('/api/1/expertmain/expertInfo/query_expert_info_list.json', { params: Object.assign(parameter, this.queryForm) }).then(res => {
          if (res.page) {
            this.total = res.page.total
          }
          return res
        })
      }
    }
  },
  methods: {
    onStartLoadData (data, confirmExpertList, type) {
      this.queryForm.groups = data.groups
      this.queryForm.ifDelete = data.ifDelete
      this.queryForm.ifExtractQuery = data.ifExtractQuery
      this.queryForm.selectAll = data.selectAll
      this.queryForm.state = data.state
      this.queryForm.type = data.type
      this.selType = type
      // 随机选取专家列表
      this.selectExpertList = []
      this.confirmExpertList = confirmExpertList
      this.reSelectList = []

      const columns = [
        { title: '姓名', align: 'center', width: 100, scopedSlots: { customRender: 'name' } },
        { title: '年龄', align: 'center', dataIndex: 'extras.age', width: 80 },
        { title: '性别', align: 'center', width: 80, dataIndex: 'gender', customRender: (text, record) => { return text === '1' ? '男' : '女' } },
        { title: '拟申报组别', align: 'center', width: 150, dataIndex: 'extras.groups_name', ellipsis: true },
        { title: '联系电话', align: 'center', width: 120, dataIndex: 'mobilePhone' },
        { title: '单位全称', align: 'left', dataIndex: 'unitName', ellipsis: true }
      ]
      if (type === '0') {
        this.deptDisabled = this.user.permissions['expert.use.admin']
      } else {
        this.deptDisabled = true
      }
      if (this.deptDisabled) {
        columns.push({ title: '操作', width: 150, align: 'center', scopedSlots: { customRender: 'operation' } })
      }
      this.columns = columns
    },
    onSubmit () {
      this.$emit('success', this.reSelectList, this.confirmExpertList)
    },
    onSearch () {
      this.$refs.table.refresh(true)
    },
    onViewModal (record) {
      this.evmVisible = true
      this.evmId = record.id
    },
    onViewReSelectModal (record, state) {
      this.reSelectExpert = record
      this.reSelectExpert.debarb = 0
      this.reSelectState = state
      if (this.reSelectState === '1') {
        this.cancelExpertList.push(record)
        this.reSelectTitle = '重抽专家理由'
        this.reSelectVisible = true
      } else if (this.reSelectState === '2') {
        this.reSelectTitle = '指定专家理由'
        if (this.selType === '1') {
          this.onOkReSelectModal()
        } else {
          this.reSelectVisible = true
        }
      } else if (this.reSelectState === '3') {
        this.reSelectTitle = '再次随机生成理由'
        this.reSelectVisible = true
      }
    },
    onOkReSelectModal () {
      let data = null
      data = {
        expertId: this.reSelectExpert.id,
        expertName: this.reSelectExpert.name,
        reason: this.reSelectReason,
        state: this.reSelectState,
        debarb: this.debarb
      }
      this.onConfirm(this.reSelectExpert)
      this.reSelectList.push(data)
      this.reSelectVisible = false
      this.initReSelectModal()
    },
    initReSelectModal () {
      this.reSelectExpert = { id: null, name: null }
      this.reSelectReason = null
    },
    // 确认专家
    async onConfirm (record) {
      // 跳过第一次添加
      if (this.confirmExpertList.length > 0) {
        // 避免重复添加
        let ifExist = false
        this.confirmExpertList.map(item => {
          if (item.id === record.id) {
            ifExist = true
          }
        })
        if (!ifExist) {
          await this.confirmExpertList.push(record)
          this.selectExpertList = await this.selectExpertList.filter(item => item.id !== record.id)
        }
      } else {
        await this.confirmExpertList.push(record)
        this.selectExpertList = await this.selectExpertList.filter(item => item.id !== record.id)
      }
    }
  }
}
</script>

<style scoped>

</style>
